import CustomBoxHeader from "../../../CommonComponents/CustomBoxHeader";
import styles from "./CompanyDetails2.module.css";
import { Row, Col } from "antd";
import { useState } from "react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { CgWebsite } from "react-icons/cg";
import { FaSquareXTwitter } from "react-icons/fa6";
import { IoLogoGithub } from "react-icons/io";
import { BsFileEarmarkPdf } from "react-icons/bs";

const CompanyDetails2 = ({ data = {}, loading, refatchData }) => {
  const [showModal, setShowModal] = useState("");

  const companyInformaton = [
    {
      label: "Education",
      value: data?.education,
    },
    {
      label: "Achievements",
      value: data?.acheivementsUrl,
    }
  ];

  const companyHQInfo = [
    {
      label: "Country",
      value: data?.country,
    },
    {
      label: "State/City",
      value: data?.state,
    },
    {
      label: "Address",
      value: data?.address,
    },
    {
      label: "Postcode/Zip",
      value: data?.postalCode,
    },
  ];

  const areaOfFocus = [
    {
      label: "Sector",
      value: data?.sector,
    },
    {
      label: "Industry",
      value: data?.industry,
    },
    {
      label: "Business function",
      value: data?.businessFunction,
    },
    {
      label: "Salary range expectation",
      value: data?.salaryRange,
    },
  ]

  const refrenceKey =
  {
    referenceEmail: "Email",
    referencefirstName: "First Name",
    referencelastName: "Last Name"
  }

  const experienceKey =
  {
    city: "City",
    country: "Country",
    title: "Title",
    startDate: "Start Date",
    endDate: "End Date",
    description: "Description"
  }

  const openQuestions =
  {
    openQ1: "1. What do you like doing outside of work and why ?",
    openQ2: "2. What would a perfect role look like for you and who else would be on the team ?",
    openQ3: "3. Which company would you most like to work for and how does their culture align with your values ?",
    openQ4: "4. In 10 years, how will you have fulfilled your purpose ?",
    openQ5: "5. In five years, how will you have fulfilled your purpose ?",
  }

  const icons = {
    linkedin: <FaLinkedin />,
    facebook: <FaFacebook />,
    fb: <FaFacebook />,
    insta: <FaInstagram />,
    Website: <CgWebsite />,
    twitter: <FaSquareXTwitter />,
    github: <IoLogoGithub />,
  };

  const handleEdit = (type) => {
    setShowModal(type);
  };

  const handleClick = (url) => {
    window.open(url, "_blank");
  };

  const handleSubmit = () => {
    refatchData();
  };

  return (
    <>
      <Row gutter={[8, 8]} className={styles.column_wrap}>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap}>
            <CustomBoxHeader
              title={"Education"}
            // action={() => handleEdit("INFO_MODAL")}
            />
            <Row gutter={[18, 24]} className={styles.data_wrap}>
              {companyInformaton.map((item) => {
                return (
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <div>
                      <div className={styles.label}>{item.label}</div>
                      <div className={styles.info}>{item.value}</div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_2}>
            <CustomBoxHeader
              title={"Company HQ Address"}
            // action={() => handleEdit("HQ_MODAL")}
            />
            <Row gutter={[12, 24]} className={styles.data_wrap}>
              {companyHQInfo.map((item) => {
                return (
                  <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <div>
                      <div className={styles.label}>{item.label}</div>
                      <div className={styles.info}>{item.value}</div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_3}>
            <CustomBoxHeader
              title={"Area of focus:"}
            // action={() => handleEdit("BIO_MODAL")}
            />
            <Row gutter={[12, 24]} className={styles.data_wrap}>
              {areaOfFocus.map((item) => {
                return (
                  <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <div>
                      <div className={styles.label}>{item.label}</div>
                      <div className={styles.info}>{item.value}</div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_4}>
            <CustomBoxHeader
              title={"About"}
            // action={() => handleEdit("BIO_MODAL")}
            />
            <div className={styles.biography}>{data?.summary}</div>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={6}
          xl={6}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_3}>
            <CustomBoxHeader
              title={"Resume"}
            // action={() => handleEdit("BIO_MODAL")}
            />
            <div className={styles.icon_wrap}>
              <BsFileEarmarkPdf />
              <a className={styles.biography} href={data?.resumes?.resume || ""} download={true}>{data?.firstName}</a>
            </div>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={6}
          xl={6}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_2}>
            <CustomBoxHeader
              title={"Certifications"}
            // action={() => handleEdit("SOCIAL_MODAL")}
            />
            <Row gutter={[24, 24]} className={styles.data_wrap}>
              {data?.certifications?.map((item) => {
                return (
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <div>
                      <div className={styles.info}>{item.name}</div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={6}
          xl={6}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_2}>
            <CustomBoxHeader
              title={"Technical Skills"}
            // action={() => handleEdit("SOCIAL_MODAL")}
            />
            <Row gutter={[8, 8]} className={styles.data_wrap}>
              {data.skills &&
                <div className={styles.tags_wrap}>
                  {data?.skills?.map((tag) => (
                    <div>{tag}</div>
                  ))}
                </div>}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={6}
          xl={6}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_2}>
            <CustomBoxHeader
              title={"Social Channels"}
            // action={() => handleEdit("SOCIAL_MODAL")}
            />
            <Row gutter={[8, 8]} className={styles.data_wrap}>
              {data.userChannels &&
                Object.keys(data.userChannels)?.map((item) => {
                  return (
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                      <div
                        className={styles.icon_wrap}
                        onClick={() => handleClick(data.userChannels[item])}
                      >
                        {icons[item]}
                        {item}
                      </div>
                    </Col>
                  );
                })}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_4}>
            <CustomBoxHeader
              title={"Experience"}
            // action={() => handleEdit("BENEFITS_MODAL")}
            />
            <Row gutter={[12, 24]} className={styles.data_wrap}>
              {data?.workExperience?.map((item) => {
                return (
                  <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                    <div>
                      <div className={styles.label_2}>{item.companyName}</div>
                      {/* {item.value.map((text) => {
                        return <p className={styles.info}>— {text}</p>;
                      })} */}
                      <Row gutter={[12, 24]} className={styles.data_wrap}>
                        {Object.keys(item)?.map((e) => {
                          if (e === 'companyName') {
                            return
                          }
                          return (
                            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                              <div>
                                <div className={styles.label}>{experienceKey[e]}</div>
                                <div className={styles.info}>{item[e]}</div>
                              </div>
                            </Col>
                          );
                        })}
                      </Row>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_3}>
            <CustomBoxHeader
              title={"Video"}
            // action={() => handleEdit("BIO_MODAL")}
            />
            <video className={styles.video_wrap} src={data?.elevatorPitch?.file} />
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_3}>
            <CustomBoxHeader
              title={"References"}
            // action={() => handleEdit("BIO_MODAL")}
            />
            <Row gutter={[12, 24]} className={styles.data_wrap}>
              {data?.references?.map((item) => {
                return (
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Row gutter={[12, 24]} className={styles.data_wrap}>
                      {Object.keys(item)?.map((e) => {
                        return (
                          <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                            <div>
                              <div className={styles.label}>{refrenceKey[e]}</div>
                              <div className={styles.info}>{item[e]}</div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className={styles.col_wrap}
        >
          <div className={styles.box_wrap_3}>
            <CustomBoxHeader
              title={"Interview Questions"}
            // action={() => handleEdit("BIO_MODAL")}
            />
            <Row gutter={[24, 24]} className={styles.data_wrap}>
              {data?.openAnswers && Object.keys(data?.openAnswers).map(item => {
                return (
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <div>
                      <div className={styles.openq_label}>{openQuestions[item]}</div>
                      <div className={styles.openq_answer}>{data?.openAnswers[item]}</div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </Col>
      </Row >
    </>
  );
};

export default CompanyDetails2;
